module.exports = __webpack_public_path__ + "img/title-.13c39895.png";